import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChatInfoPage } from './chat-info';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    ChatInfoPage,
  ],
  imports: [
		PipesModule,
    IonicPageModule.forChild(ChatInfoPage),
  ],
})
export class ChatInfoPageModule {}



// WEBPACK FOOTER //
// ./src/pages/chat-info/chat-info.module.ts